import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-meter-header',
  templateUrl: './meter-header.component.html',
  styleUrls: ['./meter-header.component.scss'],
})
export class MeterHeaderComponent {
  @Input() title: string = '';
  @Input() small: boolean = false;
}
